<!--  -->
<template>
	<div class="flex container">
		<div class="flex-box1">
			<!-- 上 -->
			<div class="title-box flex flex-between">
				<div class="title">组织部门</div>
				<div class="mt5" v-if="isEdit">
					<img class="icon-img" src="@/assets/images/edit.png" @click="handleEdit(1)" title="编辑" alt="">
					<img class="icon-img ml7" src="@/assets/images/disable.png" @click="updateStatusRow(1)" title="停用"
						alt="">
					<img class="icon-img ml7" src="@/assets/images/enable.png" @click="updateStatusRow(0)" title="启用"
						alt="">
					<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit(2)" title="新增" alt="">
					<!-- <img class="icon-img ml7" src="@/assets/images/delete.png"  alt=""> -->
				</div>
			</div>
			<!-- 树 -->
			<div class="tree-box mt10">
				<el-tree :data="treeData" :expand-on-click-node="false" node-key="groupId" ref="tree"
					:props="defaultProps" :default-expand-all="true" @node-click="nodeClick">
					<span class="custom-tree-node" slot-scope="{ node, data }">
						<!-- <div :style="data.status == 1 ? 'color:red; cursor: not-allowed; background-color: #ddd;' : ''"> -->
						<div>
							<!-- <i class="el-icon-folder-opened"></i> -->
							{{ node.label }}
							<span v-if="data.status == 1" :style="data.status == 1 ? 'color:red;' : ''">(禁用)</span>
						</div>
					</span>
				</el-tree>
			</div>
			<!--  -->
		</div>
		<div class="flex-box2">
			<el-row type="flex" :gutter="10" class="mt10">
				<el-col :span="24">
					<el-breadcrumb separator="/">
						<el-breadcrumb-item @click.native="breadcrumbClick(item)" v-for="(item,index) in breadcrumbList"
							:key="index">
							<a style="cursor:pointer">{{item.groupName}}</a>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
			</el-row>
			<!-- 上 -->
			<div class="search-box flex flex-between mt15 ">
				<div class="flex mt5 flex-wrap">
					<el-input v-model.trim="searchFrom.userName" class="w180" size="small" placeholder="用户名" @keyup.enter.native="handleSearch"
						maxlength="10" clearable>
					</el-input>
					<el-input v-model.trim="searchFrom.userCode" class="w180 ml10" size="small" placeholder="账号" @keyup.enter.native="handleSearch"
						maxlength="16" clearable>
					</el-input>
					<el-input v-model.trim="searchFrom.userPhone" class="w180 ml10" size="small" placeholder="联系电话" @keyup.enter.native="handleSearch"
						maxlength="11" clearable>
					</el-input>
					<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch" alt="">
				</div>
				<div class="mt5" v-if="isEdit">
					<img class="icon-img ml7" src="@/assets/images/delete.png" @click="deleteUsers" title="删除" alt="">
					<img class="icon-img ml7" src="@/assets/images/add.png" @click="addUsers" title="新增" alt="">
				</div>
			</div>
			<!-- 表 -->
			<!-- :max-height='height+"px"' -->
			<!-- :height="height" -->
			<div class="mt10">
				<el-table v-if="tableData.length>0" ref="multipleTable" v-el-table-infinite-scroll="tableLoad"
					:infinite-scroll-distance="50" :infinite-scroll-immediate="false" :data="tableData" :height="height"
					:row-class-name="tabRowClassName" @selection-change="handleSelectionChange" border
					style="width: 100%" :header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}">
					<el-table-column type="selection" width="50" align="center">
					</el-table-column>
					<el-table-column v-show="tableData" v-for="(value, index) in titles" :key="index" :prop="value.prop" sortable :column-key="value.prop"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{scope.row[value.prop]}}
						</template>
					</el-table-column>
				</el-table>
				<el-empty v-else description="暂无数据"></el-empty>
			</div>
			<!--  -->
		</div>
		<groupSetEdit ref="groupSetEdit" @getList="getTree"></groupSetEdit>
		<addUsers ref="addUsers" @getList="handleSearch"></addUsers>
	</div>
</template>

<script>
	import groupSetEdit from './components/groupSet-edit.vue'
	import addUsers from './components/add-users.vue'
	import {
		debounce
	} from '@/utils/debounce'
	import { hasPermission } from '@/utils/permission'
	export default {
		name:'groupSet',
		components: {
			groupSetEdit,
			addUsers
		},
		data() {
			return {
				treeData: [],
				defaultProps: {
					children: "children",
					label: "groupName"
				},
				searchFrom: {
					userCode: "",
					userName: "",
					userPhone: "",
				},
				pageNo: 1,
				pageSize: 50,
				tableData: [],
				titles: [],
				paramFrom: {
					currentName: "",
					groupId: "",
				},
				multipleSelection: [],
				breadcrumbList: [],
				height: 500,
				isEdit:false
			}
		},
		created() {
			this.height = window.innerHeight - 210;
			this.getTree();
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
				// console.log(this.isEdit)
			}
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			// 获取组织树
			getTree() {
				let that = this;
				that.$request.post(
						"tree",
						false, {
							status: 1
						}
					)
					.then((res) => {
						if (res) {
							that.treeData = res.data
							that.paramFrom = res.data[0];
							that.breadcrumbList = [];
							that.breadcrumbList.push(res.data[0]);
							that.pageNo = 1;
							that.getList()
						}
					})
			},
			// 树节点被点击
			// 传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身。
			nodeClick(data, node) {
				this.paramFrom = data;
				//循环设置breadcrumList面包屑  node 包含了本节点以及上级节点和子节点
				this.breadcrumbList = [];
				//判断node是否有上一级，有就一直循环，直到没有
				while (node.parent !== null) {
					this.breadcrumbList.unshift(node.data);
					node = node.parent;
				}

				this.pageNo = 1;
				this.getList()
				if (this.tableData.length > 0) {
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}
			},
			// 新增
			handleEdit(val) {
				if(this.paramFrom.status == 1 && val == 2) {
					this.$message.error('当前组织部门已禁用')
					return
				}
				this.$refs.groupSetEdit.init(this.paramFrom, val)
			},
			// 添加用户
			addUsers() {
				if(this.paramFrom.status == 1) {
					this.$message.error('当前组织部门已禁用')
					return
				}
				this.$refs.addUsers.init(this.paramFrom)
			},

			// 状态
			updateStatusRow(status) {
				let that = this;
				that.$request.post(
						"groupUpdateStatus",
						false, {
							groupId: that.paramFrom.groupId,
							status: status
						}
					)
					.then((res) => {
						if (res) {
							// 0:正常;1:停用
							that.$message.success(status == 0 ? "已启用！" : "已停用！");
							that.getTree()
						}
					})

			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getList('scroll');
			}, 100, true),
			// 获取用户列表
			getList(type) {
				let that = this;
				that.$request.post(
						"groupUserListPage",
						false, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							userCode: that.searchFrom.userCode,
							userName: that.searchFrom.userName,
							userPhone: that.searchFrom.userPhone,
							groupId: that.paramFrom.groupId
						}
					)
					.then((res) => {
						if (type == 'scroll') {
							that.tableData = that.tableData.concat(res.data && res.data.tableDatas || []);
						} else {
							if (res.data && res) {
								that.titles = res.data.titles
								that.tableData = res.data.tableDatas
							} else {
								that.titles = []
								that.tableData = []
							}
						}
						that.titles  = that.titles.map((item, index) => { 
									return { 
										title: item.title, 
										prop: 'tr' + index,
										maxWidth:item.maxWidth, 
									} 
								})
						that.tableData.forEach(item => {
							for (let i = 0; i < that.titles.length; i++) {
								item['tr' + i] = item.datas[i] || ''
							}
						})
					})
			},
			handleSearch() {
				this.pageNo = 1;
				this.getList();
			},
			deleteUsers() {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择用户!');
					return
				}
				that.$confirm('是否确认删除？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					let userIds = []
					that.multipleSelection.forEach(item => {
						userIds.push(item.dataKey)
					});
					console.log(that.ruleForm)
					that.$request.post(
							"groupRemoveUser",
							true, {
								groupId: that.paramFrom.groupId,
								userIds: userIds,
							}
						)
						.then((res) => {
							if (res) {
								that.dialogVisible = false
								that.$message.success("删除成功！");
								that.pageNo = 1;
								that.getList()
							}
						})
				}).catch(() => {});
			},
			// 列多选
			handleSelectionChange(val) {
				console.log(val)
				this.multipleSelection = val;
			},
			//面包屑点击
			breadcrumbClick(data) {
				let that = this;
				that.paramFrom = data;
				//从后往前循环breadcrumbList面包屑列表，如果ID不相等，就把它去了。
				for (let i = that.breadcrumbList.length; i > 0; i--) {
					if (that.breadcrumbList[i - 1].groupId !== data.groupId) {
						that.breadcrumbList.pop();
					} else {
						break;
					}
				}
				that.pageNo = 1;
				that.getList()
				that.$forceUpdate();
			},
		},
		beforeDestroy() {

		}
	}

</script>

<style lang='scss' scoped>
	.container {
		height: calc(100% - 15px)
	}

	.flex-box1 {
		width: 30%;
		padding: 10px;
		// height: 100%;
		box-sizing: border-box;

		.title-box {
			background: #F9FAFD;
			height: 40px;
			line-height: 40px;
			padding: 10px;

			.title {
				font-weight: bold;
			}
		}

		.tree-box {
			width: 100%;
			height: 93%;
			box-sizing: border-box;
			overflow-y: auto;
		}
	}

	.flex-box2 {
		width: 70%;
		padding: 10px;
		height: 100%;
		box-sizing: border-box;

		.search-box {
			background: #F9FAFD;
			padding: 5px;
		}
	}

	.w180 {
		width: 180px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 0px;
		}

		/deep/ td {
			padding: 5px;
		}

		/deep/ .warning-row {
			background: #F1F1F5;
		}
		/deep/ th .el-table__cell{
				padding: 0 !important;
			}
	}

	.el-breadcrumb__inner a {
		font-size: 16px;
		color: #000 !important;
		font-weight: normal;
	}

	.el-breadcrumb {
		line-height: 20px;
	}

</style>
